export const NEGATIVE = "NEGATIVE";
export const POSITIVE = "POSITIVE";
